import { mergeStyles } from "@fluentui/merge-styles";
import { tokens } from "@fluentui/react-components";

export const AVATAR_COLORS = [
  '#ca5010', '#986f0b', '#498205', '#038387', '#0078d4', '#8764b8',
  '#881798', '#c239b3', '#e3008c', '#e74856', '#d13438', '#ff8c00',
  '#107c10', '#00b294',
];

export const getColorIndex = (name: string) =>
  [...name].reduce((sum, c) => sum + c.charCodeAt(0), 0) % AVATAR_COLORS.length;

export const circularCheckboxBaseClass = mergeStyles({
  width: 24,
  height: 24,
  minWidth: 24,
  borderRadius: '50%',
  border: 'none',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '10px',
  fontWeight: '600',
  color: '#fff',
  padding: 0,
  flexShrink: 0,
  transition: 'background-color 0.1s ease',
  ':focus-visible': {
    outline: `2px solid ${tokens.colorBrandForeground1}`,
    outlineOffset: '2px',
  },
});

export const circularCheckboxCheckedClass = mergeStyles({
  backgroundColor: tokens.colorBrandBackground,
});

export const circularCheckboxIndeterminateClass = mergeStyles({
  backgroundColor: tokens.colorBrandBackground,
});

export const circularCheckboxUncheckedClass = (bg: string) =>
  mergeStyles({ backgroundColor: bg });

export const circularCheckboxSelectAllUncheckedClass = mergeStyles({
  backgroundColor: 'transparent',
  border: `1.5px solid ${tokens.colorNeutralStroke1}`,
});
